export default function guest ({ next, store }){
    if(store.state.auth.portfolio || window.userAuth){
        return next({
            name: 'dashboard'
        });
    }

    return next();
}